<template>
<md-sidenav class="md-left" ref="projectSettingsNav">
    <md-dialog-confirm
        :md-title="confirm.title"
        :md-content-html="getConfirmContent()"
        :md-ok-text="confirm.ok"
        :md-cancel-text="confirm.cancel"
        @close="deleteProjectConfirm"
        ref="deleteProjectDialog">
    </md-dialog-confirm>
    <md-toolbar class="md-dense main-toolbar">
        <md-button class="md-icon-button" @click="back()">
            <md-icon>menu</md-icon>
        </md-button>
        <h3 class="md-title">Project Settings</h3>
    </md-toolbar>
    <md-layout md-flex="90" md-flex-offset="5" v-if="ownerUID === user.uid">
        <form novalidate @submit.stop.prevent="open" >
            <h1 class="md-title">Project Name</h1>
            <md-input-container>
                <md-input v-model="title"></md-input>
            </md-input-container>
            <md-button class="md-raised md-primary" @click="updateTitle">Rename</md-button>
<!--             <h1 class="md-title">Toggle Show/Night Mode</h1>
            <md-switch v-model="nightMode" class="md-primary">Enable</md-switch> -->
        </form>
    </md-layout>
    <md-layout md-column md-flex="90" md-flex-offset="5" v-else>
        <h1 class="md-title">Project Name</h1>
        <span class="md-body-2">{{ project.title }}</span>
    </md-layout>
    <!-- <md-layout class="delete-section" md-flex="90" md-flex-offset="5" v-if="ownerUID === user.uid">
        <md-button @click="deleteProject" class="md-warn md-raised">Delete Project</md-button>
    </md-layout> -->
</md-sidenav>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';
import NavBus from '@/buses/nav';

const ProjectSettingsNav = {
    name: 'CoreHeader',
    props: ['project'],
    data: function() {
        return {
            nightMode: false,
            title: '',
            confirm: {
                title: 'Confirm Project Delete',
                ok: 'yes',
                cancel: 'Cancel'
            }
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'ownerUID',
            'collaborators',
            'cues'
        ]),
        projectRef: function() {
            return firebase.database().ref(`/projects/${this.project.id}`);
        }
    },
    methods: {
        updateTitle() {
            this.projectRef.update({title: this.title});
        },
        closeProjectSettingsNav() {
            this.$refs.projectSettingsNav.close();
        },
        back() {
            this.closeProjectSettingsNav();
            NavBus.$emit('main-nav.open');
        },
        getConfirmContent() {
            const numCollaborators = this.collaborators.length;
            const numCues = this.cues.length;
            return `Warning, you are about to delete a project with <strong>${numCollaborators}</strong> collaborators and <strong>${numCues}</strong> cues already written! Please confirm you would like to delete this project.`;
        },
        deleteProject() {
            this.$refs.deleteProjectDialog.open();
        },
        deleteProjectConfirm(type) {
            if (type === 'ok') {
                this.$store.dispatch('deleteProject', this.project.id);
                this.$router.replace('/dashboard');
            }
        }
    },
    created: function() {
        NavBus.$on('project-settings-nav.open', () => {
            if (this.$refs.projectSettingsNav) {
                this.title = this.project.title;
                this.$refs.projectSettingsNav.open();
            }
        });
    }
};
export default ProjectSettingsNav;

</script>

<style lang="scss">
.delete-section {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// nav.vue?ecdf2ff8